/**
 * Sepette tek bayi kuralı.
 *
 * Aynı anda yalnızca TEK bir satıcının (Shopify "vendor" alanı) ürünü sipariş
 * edilebilir. Sepette Trendmiya ürünü varken Lilyana ürünü eklenemez, tersi de
 * geçerli. Sebep: her bayi kendi deposundan, kendi kuryesiyle, kendi teslimat
 * gün/saatiyle çıkıyor - karışık bir sepetin tek bir teslimat randevusu olamaz.
 *
 * NEDEN "ekledikten sonra geri alma" yöntemi:
 * Sepete ekleme isteğinde yalnızca varyant kimliği var, ürünün bayisi yok;
 * Shopify'ın varyanttan bayiye giden açık bir ucu da yok. Ama /cart/add.js
 * CEVABI eklenen satırı bayisiyle birlikte döndürüyor. Bu yüzden istek geçiyor,
 * cevaptaki bayi sepettekiyle uyuşmuyorsa o satır anında geri alınıyor ve
 * müşteriye açıklama gösteriliyor.
 *
 * İki koruma katmanı var:
 *  1. AJAX ile ekleme (tema sepet çekmecesi, hızlı ekle) - anında geri alınır.
 *  2. Formun doğrudan gönderilmesi (JS kapalı / farklı akış) - sayfa
 *     yüklenirken sepet taranır, karışık sepette uyarı çıkar ve ödeme kilitlenir.
 *
 * Bu dosya tema özelinde çalışır, AGT teslimat uygulamasından bağımsızdır.
 */
(function () {
  if (window.__trendmiyaSingleVendorCart) return;
  window.__trendmiyaSingleVendorCart = true;

  var NOTICE_CLASS = "tm-vendor-notice";

  /** Sepetteki farklı bayi adları (boş olanlar sayılmaz). */
  function vendorsOf(cart) {
    var seen = [];

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var vendor = (item.vendor || "").trim();
      if (vendor && seen.indexOf(vendor) === -1) seen.push(vendor);
    });

    return seen;
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /** /cart/add.js cevabı tek ürün ({...}) ya da çoklu ({items:[...]}) olabilir. */
  function addedItemsOf(payload) {
    if (!payload) return [];
    if (Array.isArray(payload.items)) return payload.items;
    if (payload.key || payload.variant_id) return [payload];
    return [];
  }

  /**
   * Satırı eklemeden önceki adedine döndürür (yeni satırsa siler).
   * Satır numarası değil key kullanılıyor: özellik/adet değişiminde satırların
   * sırası kayabiliyor.
   */
  function restoreLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).catch(function () {});
  }

  function showNotice(message, reloadOnClose) {
    document.querySelectorAll("." + NOTICE_CLASS).forEach(function (el) {
      el.remove();
    });

    var box = document.createElement("div");
    box.className = NOTICE_CLASS;
    box.innerHTML =
      '<div class="' + NOTICE_CLASS + '__inner">' +
      '<p class="' + NOTICE_CLASS + '__text"></p>' +
      '<button type="button" class="' + NOTICE_CLASS + '__close">Tamam</button>' +
      "</div>";

    box.querySelector("." + NOTICE_CLASS + "__text").textContent = message;

    box.querySelector("." + NOTICE_CLASS + "__close").addEventListener("click", function () {
      box.remove();
      // Tema, sepete ekleme cevabıyla çekmeceyi çoktan çizdi; geri aldığımız
      // satır orada hâlâ görünüyor olabilir. Yenileme, sepetin gerçek hâlini
      // göstermenin tema bağımsız tek güvenli yolu.
      if (reloadOnClose) window.location.reload();
    });

    document.body.appendChild(box);
  }

  /**
   * Eklemeden ÖNCEKİ sepet ile eklenen satırları karşılaştırır; farklı bayi
   * geldiyse geri alır.
   */
  function enforceAfterAdd(previousCart, responsePayload) {
    var existingVendors = vendorsOf(previousCart);

    if (existingVendors.length === 0) return;

    var keptVendor = existingVendors[0];
    var offending = addedItemsOf(responsePayload).filter(function (item) {
      var vendor = (item.vendor || "").trim();
      return vendor && vendor !== keptVendor;
    });

    if (offending.length === 0) return;

    var previousQuantities = {};
    (previousCart.items || []).forEach(function (item) {
      previousQuantities[item.key] = item.quantity;
    });

    var rollbacks = offending.map(function (item) {
      return restoreLine(item.key, previousQuantities[item.key] || 0);
    });

    Promise.all(rollbacks).then(function () {
      var rejectedVendor = (offending[0].vendor || "").trim();

      showNotice(
        'Sepetinizde "' + keptVendor + '" ürünleri var. Aynı anda yalnızca tek bir satıcıdan ' +
          'sipariş verebilirsiniz, çünkü her satıcının teslimatı kendi kuryesiyle ayrı çıkıyor. ' +
          '"' + rejectedVendor + '" ürününü sipariş etmek için önce sepetinizi boşaltın.',
        true
      );
    });
  }

  // --- 1. Katman: AJAX ile sepete ekleme ---------------------------------

  var originalFetch = window.fetch;

  window.fetch = function (resource, config) {
    var url = typeof resource === "string" ? resource : (resource && resource.url) || "";
    var isAdd = url.indexOf("/cart/add") !== -1;

    if (!isAdd) return originalFetch.apply(this, arguments);

    var self = this;
    var args = arguments;

    return fetchCart().then(function (previousCart) {
      return originalFetch.apply(self, args).then(function (response) {
        if (response.ok) {
          // clone(): gövdeyi biz okursak temanın kendi okuması boş kalırdı.
          response
            .clone()
            .json()
            .then(function (payload) {
              enforceAfterAdd(previousCart, payload);
            })
            .catch(function () {});
        }

        return response;
      });
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tmUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;

    if (xhr.__tmUrl && String(xhr.__tmUrl).indexOf("/cart/add") !== -1) {
      // Sepetin eklemeden önceki hâlini yakalıyoruz; istek beklemiyor,
      // cevap geldiğinde hazır olması yeterli.
      var snapshot = fetchCart();

      xhr.addEventListener("load", function () {
        if (xhr.status < 200 || xhr.status >= 300) return;

        snapshot.then(function (previousCart) {
          try {
            enforceAfterAdd(previousCart, JSON.parse(xhr.responseText));
          } catch (e) {
            /* cevap JSON değilse yapacak bir şey yok */
          }
        });
      });
    }

    return originalSend.apply(this, arguments);
  };

  // --- 2. Katman: sayfa açılışında karışık sepet kontrolü -----------------

  function lockCheckout() {
    var selectors = [
      '[name="checkout"]',
      'a[href^="/checkout"]',
      ".cart__checkout-button",
      "#checkout",
      "#CartDrawer-Checkout"
    ].join(", ");

    document.querySelectorAll(selectors).forEach(function (el) {
      el.setAttribute("disabled", "disabled");
      el.setAttribute("aria-disabled", "true");
      el.style.opacity = "0.5";
      el.style.pointerEvents = "none";
    });
  }

  function enforceOnLoad() {
    fetchCart().then(function (cart) {
      var vendors = vendorsOf(cart);
      if (vendors.length < 2) return;

      // Formun doğrudan gönderildiği (AJAX'sız) akışta buraya düşülür.
      // Otomatik silmiyoruz: hangi satıcıyı tutmak istediğine müşteri karar
      // vermeli, sessizce ürün silmek daha kötü olurdu.
      lockCheckout();
      showNotice(
        "Sepetinizde birden fazla satıcının ürünü var (" + vendors.join(", ") + "). " +
          "Aynı anda yalnızca tek bir satıcıdan sipariş verebilirsiniz. " +
          "Lütfen sepetinizden bir satıcının ürünlerini çıkarın.",
        false
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enforceOnLoad);
  } else {
    enforceOnLoad();
  }
})();
